export const MOCK_SITE_SETTINGS = [
  {
    "slug": "onboarding_screen",
    "settings": {
      "otp": {
        "image": "https://cdn.example.com/onboarding/otp.png",
        "title": "Verify OTP",
        "cta_text": "Verify"
      },
      "splash_screen": {
        "title": "Welcome to Streamly",
        "sub_title": "Unlimited entertainment starts here"
      },
      "authentication": {
        "image": "https://cdn.example.com/onboarding/auth.png",
        "title": "Login to Continue",
        "sub_title": "Access your personalised experience",
        "cta_text": "Continue"
      }
    },
    "status": 1,
    "is_delete": 0,
    "createdAt": "2026-01-20T14:46:40.141Z",
    "createdBy": 1,
    "updatedAt": "2026-01-20T14:46:40.141Z",
    "updatedBy": null
  }
]


